module.exports = __webpack_public_path__ + "static/media/profile-action-icon-compare-locked.5a9f400d.svg";